// this is an autogenerated file from App/ChooseLocation/ParentCompanies/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_ChooseLocation_ParentCompanies($user_id: uuid!) {
  app_admin_users_access(
    where: { organization_level: { _eq: "parent" }, user_id: { _eq: $user_id } }
    order_by: { organization_name: asc }
  ) {
    id
    xid
    text: organization_name
  }
}

`